module.exports = __webpack_public_path__ + "img/1.6e5bd00a.jpg";